import React, { forwardRef, useEffect, useImperativeHandle, useState } from 'react';
import CardEmpty from 'Utils/Cards/CardEmpty';
import moment from 'moment/moment';
import LoadMask from '../../../../Utils/LoadMask/LoadMask';
import Paginacion from '../../../../Utils/Components/Paginacion/Paginacion';
import { RecepcionesFletesApi } from '../../../../Utils/APIs/bonificacionesApi/RecepcionesFletesApi';
import TablaBonifFletes from '../../../../Utils/Components/RecepcionesBonificacion/TablaBonifFletes/TablaBonifFletes';
import TotalesBonificacion from '../../../../Utils/Components/TotalesBonificacion/TotalesBonificacion';
import "react-datepicker/dist/react-datepicker.css";

/**
 * Componente para mostrar recepciones donde se aplicó bonificación por costo de flete.
 * @param {Object} props - Props del componente.
 * @param {Object} props.filtros - Filtros para la consulta de recepciones.
 * @param {Object} ref - Referencia para acceder a métodos del componente.
 * @returns {JSX.Element} Componente RecepcionesFletes.
 */
const RecepcionesFletes = forwardRef((props, ref) => {
    // API
    const { filtros, proveedorId = undefined } = props;

    useImperativeHandle(ref, () => ({
        aplicarFiltros: () => {
            getData();
        },
    }));

    const { getRecepcionesFletes, getTotalesFletes, cargando } = RecepcionesFletesApi();

    // RECEPCIONES
    const [recepciones, setRecepciones] = useState([]);
    const [paginaSeleccionada, setPaginaSeleccionada] = useState(1);
    const [cantidadResultados, setCantidadResultados] = useState(0);

    // TOTALES
    const [totalesBonificacion, setTotalesBonificacion] = useState({
        total_bonificaciones: 0,
        total_kg: 0,
        total_bonos: 0,
        total_bonos_quetzales: 0,
    });

    // CONSULTA DE DATOS
    const formatFiltros = () => {
        const fecha_inicial = moment(filtros.fecha_inicial).format("YYYY-MM-DD");
        const fecha_fin = moment(filtros.fecha_fin).format("YYYY-MM-DD");
        const finca_id = filtros.finca_id || '';
        return { fecha_inicial, fecha_fin, finca_id };
    }

    const getRecepciones = async () => {
        const { fecha_inicial, fecha_fin, finca_id } = formatFiltros();

        const params = {
            page: paginaSeleccionada,
            pageSize: 10,
            paginar: true,

            fecha_inicial,
            fecha_fin,
            finca_id,

            proveedor_id: proveedorId,
        };

        const recepcionesFletes = await getRecepcionesFletes(params);
        setRecepciones(recepcionesFletes.results);
        setCantidadResultados(recepcionesFletes.count);
    }

    const getTotales = async () => {
        const { fecha_inicial, fecha_fin, finca_id } = formatFiltros();

        const params = {
            fecha_inicial,
            fecha_fin,
            finca_id,

            proveedor_id: proveedorId,
        };

        const totales = await getTotalesFletes(params);
        setTotalesBonificacion(totales);
    }

    const getData = async () => {
        await getRecepciones();
        await getTotales();
    }

    useEffect(() => {
        getRecepciones();
    }, [paginaSeleccionada]);

    useEffect(() => {
        getTotales();
    }, [])

    return (
        <CardEmpty noShadow>
            <div className="dash-prov-recep-bonif">
                <h4 className='text-center mb-3'>Bonificación por Transporte</h4>
                {/* TABLA */}
                <LoadMask loading={cargando} blur>
                    <div className='new-table-wrapper'>
                        <TablaBonifFletes recepciones={recepciones} reportMode={true} />
                    </div>

                    {/* PAGINACIÓN */}
                    <Paginacion cantidadResultados={cantidadResultados}
                        paginaSeleccionada={paginaSeleccionada}
                        setPaginaSeleccionada={setPaginaSeleccionada}
                    />

                    {/* TOTALES */}
                    <TotalesBonificacion
                        totalesBonificacion={totalesBonificacion}
                    />
                </LoadMask>
            </div>
        </CardEmpty>
    )
});

export default RecepcionesFletes;
